module.exports = __webpack_public_path__ + "593250ee9a9ace671510e49a591b51dc.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-768.webp
// module id = 461
// module chunks = 0